'use client'

import { createContext, useContext } from 'react'

export type ProductDiscountBoundaries = {
  max?: number
  min?: number
}

export type ProductConfigContextValue = {
  discountBoundaries?: ProductDiscountBoundaries
}

/**
 * The context contains the `product` domain-specific static configuration
 */
export const ProductConfigContext = createContext<ProductConfigContextValue>({})

export const useProductConfigContext = (): ProductConfigContextValue =>
  useContext(ProductConfigContext)
